/* eslint react-hooks/rules-of-hooks: 0 */
import * as React from 'react'
import hoistNonReactStatics from 'hoist-non-react-statics'
import { Router, type BaseLocationHook } from 'wouter'
import { useRouter } from 'next/router'

function normalizePath(path: string, locale?: string) {
  const pathname = path.split(/[?#]/)[0] || '/'

  if (!locale) return pathname

  if (pathname === `/${locale}`) return '/'

  if (pathname.startsWith(`/${locale}/`)) {
    return pathname.slice(locale.length + 1) || '/'
  }

  return pathname
}

function useNextRouterLocation(): ReturnType<BaseLocationHook> {
  const router = useRouter()
  const locale = router.locale

  const location = React.useMemo(
    () => normalizePath(router.asPath || '/', locale),
    [router.asPath, locale],
  )

  const navigate = React.useCallback(
    (to: string) => {
      router.push(to, to, { locale, scroll: false })
    },
    [router, locale],
  )

  return [location, navigate]
}

export default function WouterHOCWrapper<T extends Record<string, any>>(
  WrappedComponent: React.ComponentType<T>,
) {
  function wouterHOC(props: T) {
    return (
      <Router hook={useNextRouterLocation}>
        <WrappedComponent {...props} />
      </Router>
    )
  }

  hoistNonReactStatics(wouterHOC, WrappedComponent)
  return wouterHOC
}
